<app-tool-bar [title]="'Authenticate Domain'" [iconName]="'pi-shield'" [isAdd]="true"
    (handleAdd)="handleAddDomainAuth()"></app-tool-bar>

<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="domainData" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
              
                <th style="min-width: 200px">Domain</th>
                <th style="min-width: 150px; text-align: center">SPF Token</th>
                <th style="min-width: 150px; text-align: center">DKIM Tokens</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-rowData>
            <tr>
               

                <!-- Domain -->
                <td>{{ rowData.domain }}</td>

                <!-- SPF Token -->
                <td style="text-align: center">
                    <ng-container [ngSwitch]="rowData.status">
                        <i *ngSwitchCase="'Success'"
                            class="pi pi-check-circle text-green-500 text-2xl cursor-pointer transform transition-transform hover:scale-125"
                            pTooltip="Success" tooltipPosition="top"></i>

                        <i *ngSwitchCase="'Failed'"
                            class="pi pi-times-circle text-red-500 text-2xl cursor-pointer transform transition-transform hover:scale-125"
                            pTooltip="Failed" tooltipPosition="top"></i>

                        <i *ngSwitchCase="'Pending'"
                            class="pi pi-exclamation-triangle text-orange-500 text-2xl cursor-pointer transform transition-transform hover:scale-125"
                            pTooltip="Pending" tooltipPosition="top"></i>

                        <span *ngSwitchDefault class="text-gray-400 text-lg">N/A</span>
                    </ng-container>

                </td>

                <!-- DKIM Tokens -->
                <td style="text-align: center">
                    <ng-container [ngSwitch]="rowData.status">
                        <i *ngSwitchCase="'Success'"
                            class="pi pi-check-circle text-green-500 text-2xl cursor-pointer transform transition-transform hover:scale-125"
                            pTooltip="Success" tooltipPosition="top"></i>

                        <i *ngSwitchCase="'Failed'"
                            class="pi pi-times-circle text-red-500 text-2xl cursor-pointer transform transition-transform hover:scale-125"
                            pTooltip="Failed" tooltipPosition="top"></i>

                        <i *ngSwitchCase="'Pending'"
                            class="pi pi-exclamation-triangle text-orange-500 text-2xl cursor-pointer transform transition-transform hover:scale-125"
                            pTooltip="Pending" tooltipPosition="top"></i>

                        <span *ngSwitchDefault class="text-gray-400 text-lg">N/A</span>
                    </ng-container>
                </td>



                <!-- Created At -->
                <td>{{ rowData.createdAt | date: 'short' }}</td>

                <!-- Updated At -->
                <td>{{ rowData.updatedAt | date: 'short' }}</td>

                <!-- Actions -->
                <td>
                    <div *ngIf="!loading" (click)="setDomainData(rowData)"  class="cursor-pointer">
                        <p-menu [tabindex]="undefined" #menu [model]="domainActionItems" [popup]="true"
                            appendTo="body"
                            ></p-menu>
                        <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                    </div>
                </td>
            </tr>
        </ng-template>

        <!-- Loading -->
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="7" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- Empty -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="7" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>



<p-dialog [modal]="true"
*ngIf="isAddDomain"
[(visible)]="isAddDomain" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-add-auth-domain (close)="isAddDomain = false; isShowEditDetails = false"
    [isShowEditDetails]="isShowEditDetails"
    [type]="isShowEditDetails ? 'View' : 'Add'"
    [domainData]="domainDataToEdit"
    (reload)="loadData()"></app-add-auth-domain>
</p-dialog>



<p-dialog [modal]="true"
*ngIf="openDeleteDialog"
[(visible)]="openDeleteDialog" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-delete-domain (close)="openDeleteDialog = false"
    [editDomainData]="domainDataToEdit"
    (reload)="loadData()"></app-delete-domain>
</p-dialog>